require('jquery-smooth-scroll');
import { screenCategory } from 'lib/utils';
let carousel = require('lib/carousel');

carousel($('.posts-container'), {
    pageSize: screenCategory() <= 2 ? 1 : 3,
});

// on click of the comment button, bring the user to the comments section
$('.btn-comment').smoothScroll({
    scrollTarget: '.comments-container'
});


// WEBPACK FOOTER //
// ./assets/js/app/pages/blog-post.js